import { FlexMeasureAdapter } from "./FlexMeasureAdapter";
import { InlineFlowMeasureAdapter } from "./InlineFlowMeasureAdapter";
import { LayoutMeasureAdapter, LayoutMeasureContext } from "./types";

const adapters: LayoutMeasureAdapter[] = [new FlexMeasureAdapter(), new InlineFlowMeasureAdapter()];

function getOwnContentWidth(container: HTMLElement): number {
  const cs = window.getComputedStyle(container);
  const rect = container.getBoundingClientRect();
  const borderLeft = parseFloat(cs.borderLeftWidth) || 0;
  const borderRight = parseFloat(cs.borderRightWidth) || 0;
  const paddingLeft = parseFloat(cs.paddingLeft) || 0;
  const paddingRight = parseFloat(cs.paddingRight) || 0;
  return Math.max(0, rect.width - borderLeft - borderRight - paddingLeft - paddingRight);
}

function getBlockContainerContentWidth(container: HTMLElement): number {
  let el: HTMLElement | null = container.parentElement;
  while (el) {
    const cs = window.getComputedStyle(el);
    const display = cs.display;
    const isInline = display === "inline" || display === "inline-block" || display === "ruby";
    if (!isInline) {
      const rect = el.getBoundingClientRect();
      const borderLeft = parseFloat(cs.borderLeftWidth) || 0;
      const borderRight = parseFloat(cs.borderRightWidth) || 0;
      const paddingLeft = parseFloat(cs.paddingLeft) || 0;
      const paddingRight = parseFloat(cs.paddingRight) || 0;
      return Math.max(0, rect.width - borderLeft - borderRight - paddingLeft - paddingRight);
    }
    el = el.parentElement;
  }
  return 0;
}

export function getLayoutMeasureContext(element: HTMLElement): LayoutMeasureContext {
  const style = window.getComputedStyle(element);
  const ownContentWidth = getOwnContentWidth(element);
  const blockContainerContentWidth = getBlockContainerContentWidth(element);
  const isInlineLike =
    style.display === "inline" || style.display === "inline-flex" || style.display === "inline-grid";

  let contentWidth = ownContentWidth;
  if (isInlineLike && blockContainerContentWidth > ownContentWidth + 1 && !element.style.width) {
    contentWidth = blockContainerContentWidth;
  } else if (contentWidth <= 0) {
    contentWidth = blockContainerContentWidth;
  }

  return {
    display: style.display,
    contentWidth,
    ownContentWidth,
    blockContainerContentWidth,
  };
}

export function resolveLayoutMeasureAdapter(
  element: HTMLElement,
  context: LayoutMeasureContext,
): LayoutMeasureAdapter {
  return adapters.find((adapter) => adapter.supports(element, context)) ?? adapters[adapters.length - 1];
}
